import Head from "next/head";
import Layout from "../components/Layout";
import webengage from "@/webengage";

export default function ContactUs() {
  return (
    <Layout>
      <Head>
        <title>Contact Us - AstroLearn</title>
      </Head>
      <section className="p-3 flex flex-col items-center">
        <div className="flex flex-col text-center">
          <span className="font-lato font-[600] text-black text-[1.56rem]">
            Contact Us
          </span>
          <span className="text-[#44443] font-[400] text-[1.125rem] mt-[16px]">
            Working Hours (10 AM - 10 PM)
          </span>
        </div>
        <div className="bg-white font-light rounded-[8px] w-[100%] space-y-[2.5rem] my-[32px] px-[1.375rem] py-[2rem]">
          <div className="flex flex-row space-x-3 items-center">
            <img src="/location.svg " className="w-[32px] h-[32px]"></img>
            <div className="flex flex-col">
              <span className="text-black font-[500] font-lato text-[1.125rem]">
                Phone
              </span>
              <span className="text-black text-[16px] font-[300] font-lato text-nowrap">
                Call us directly on{" "}
                <a
                  href="tel:7973938627"
                  className="text-black text-[16px] font-[400] underline underline-offset-2 font-lato text-nowrap"
                  onClick={() => {
                    const _webengage = webengage();
                    if (_webengage) {
                      _webengage.track("Contact Us", {
                        source: "Astrolearn",
                        type: "Call",
                      });
                    }
                  }}
                >
                  797-393-8627
                </a>
              </span>
            </div>
          </div>
          <div className="flex flex-row space-x-3 items-center my-[32px]">
            <img src="/whatsapp.svg" className="w-[32px] h-[32px]"></img>
            <div className="flex flex-col">
              <span className="text-black font-[500] font-lato text-[1.125rem]">
                Whatsapp
              </span>
              <span className="text-black text-[16px] font-[300] font-lato text-nowrap">
                Whatsapp us on{" "}
                <a
                  href="https://wa.me/+919056187997"
                  onClick={() => {
                    const _webengage = webengage();
                    if (_webengage) {
                      _webengage.track("Contact Us", {
                        source: "Astrolearn",
                        type: "Chat",
                      });
                    }
                  }}
                >
                  <span className="text-black text-[16px] font-[400] font-lato text-nowrap">
                    +919056187997
                  </span>
                </a>
              </span>
            </div>
          </div>
          <div className="flex flex-row space-x-3 items-center">
            <img src="/phone.svg" className=" align-top"></img>
            <div className="flex flex-col">
              <span className="text-black font-[500] font-lato text-[1.125rem">
                Address
              </span>
              <span className="text-black text-[16px] font-[300] font-lato text-balance">
                Dhindsa Tower 1, D-250 Sector 75, Sahibzada Ajit Singh Nagar, Punjab 160071
              </span>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
}
